module.exports = __webpack_public_path__ + "img/0.bb44156f.jpg";